import Help from './Help';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { globalStyles as styles } from './style/gstheme';
import TitledPanel from './TitledPanel';

class MissingImports extends React.Component {

    render() {

        const { classes, ignoreMissingImports, onChange, margin } = this.props;
        const value = ignoreMissingImports === undefined ? "undefined" : ignoreMissingImports.toString();

        return (
            <TitledPanel height="full" title="OWL Imports" margin={margin}>
                <FormControl component="fieldset" style={{ marginLeft: 12 }}>
                    <legend className={classes.hideLegend}>OWL import approach</legend>
                    <RadioGroup row aria-label="OWL import options" name="handleMissingImports" value={value} onChange={onChange}>
                        <FormControlLabel data-test="select-ignore-completely" value="undefined" control={<Radio color="primary" />} label="Ignore Completely"
                            classes={{ label: classes.formLabelInline }}
                        />
                        <FormControlLabel data-test="select-not-downloadable" value="true" control={<Radio color="primary" />} label="Ignore Not Downloadable"
                            classes={{ label: classes.formLabelInline }}
                        />
                        <FormControlLabel data-test="select-fail-all" value="false" control={<Radio color="primary" />} label="Fail Not Downloadable"
                            classes={{ label: classes.formLabelInline }}
                        />
                    </RadioGroup>
                </FormControl>
            </TitledPanel>
        );
    }
}

MissingImports.defaultProps = {
    margin: true
};

MissingImports.propTypes = {
    ignoreMissingImports: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    classes: PropTypes.object,
    margin: PropTypes.bool
};

export default withStyles(styles)(MissingImports);